export interface MakeupActivityStateModel {
  makeupActivities: MakeupActivityModel[];
  loading: LoadingMakeupActivityState;
  error: any | null;
}

export interface MakeupActivityModel {
  id: string;
  sessionId: string;
  weeklyScheduleId: string;
  learningId: string;
  userId: string;
  userName: string;
  PGYLevel: string | null;
  track: string;
  group: string;
  applicationId: string;
  associatedMedicalSchool: string;
  postgraduateTrainingProgram: string;
  attendance: 'Absent' | 'AWOL';
  makeupCompleted: boolean | null;
  makeupComment: string | null;
  comment: string;
}

export interface MakeupActivityRequest {
  id: string;
  makeupCompleted: boolean;
  comment?: string;
}

export interface MakeupActivityScheduleRequest {
  weeklyScheduleId: string;
  sessionId: string;
}

export enum LoadingMakeupActivityState {
  loadingList = 'loadingList',
  loadingAddUpdate = 'loadingAddUpdate',
  notLoading = 'notLoading',
}
